import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { v4 as uuidv4 } from 'uuid';
import styles from './styles.scss';

const cx = classNames.bind(styles);

export default function Input({
  value, label, error, success, onChange, className, placeholder,
}) {
  const inputId = useMemo(() => uuidv4(), []);

  return (
    <div className={`${cx('container')} ${className}`}>
      {label && (
        <label htmlFor={inputId} className={cx('label', 'small')}>
          {label}
        </label>
      )}
      <input
        id={inputId}
        value={value}
        placeholder={placeholder}
        className={cx('input', { error, success })}
        onChange={e => onChange(e.target.value)}
      />
      <span className={cx({ error, success }, 'xsmall')}>{error || success}&nbsp;</span>
    </div>
  );
}
Input.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  success: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};
Input.defaultProps = {
  value: undefined,
  label: null,
  error: null,
  success: null,
  className: '',
  placeholder: '',
};
